import React, {useState, useEffect} from 'react';
import {Container, Row, Col} from 'reactstrap';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import BasicText from '../DebtPaymentComponents/basicText';
import BasicImage from '../DebtPaymentComponents/basicImage';
import {errorEnum} from '../DebtPaymentComponents/debtPaymentEnum';
import Action from '../DebtPaymentComponents/action';
import Config from '../../../../Config';
import gaParams from '../../../../utilities/analytics/constants';
import {gaEvent} from '../../../../utilities/analytics/tracking';
import {numWithStarRTL} from '../../../../utilities/StringHelpers/StringHelpers';
import {CSSTransition} from 'react-transition-group';
import {report, getReportParams} from '../../../../middleware/report';

import '../debtPayment.scss';
import '../debtPaymentAnimations.scss';

const GeneralErrorPrivate = (props) => {
  const [mount, setMount] = useState(false);

  let mainImg = require('../images/icons-error.svg');

  let title = 'שירות זה אינו זמין';
  let dial = require('../images/icons-call-phone.svg');
  let actionText = props.isMobile ? 'חיוג ' + numWithStarRTL(Config.businessCallNumber) + 'לאחראי שירות' : 'לפנייה לנציג שירות יש לחייג למספר ';

  //let bodyText = props.isMobile ? 'אנחנו לא יכולים להשלים כרגע את\n התהליך. כדאי לנסות שוב עוד כמה\n רגעים או להסדיר את התשלום דרך\n המוקד הפיננסי שלנו' :
  const actionOnClick = (e) => {
    gaEvent(gaParams.PRIVATEDEBT_SPECIALERROR_CALL_CLICK.category, gaParams.PRIVATEDEBT_SPECIALERROR_CALL_CLICK.eventType, 'כללי');
    window.open('tel:' + e);
  };

  useEffect(() => {
    if (props.currentStep === errorEnum.GENERALPRIVATE) {
      setMount(true);
      gaEvent(
        gaParams.PRIVATEDEBT_GENERALERROR_SHOW.category,
        gaParams.PRIVATEDEBT_GENERALERROR_SHOW.eventType,
        gaParams.PRIVATEDEBT_GENERALERROR_SHOW.eventParams,
      );
      let reportParams = getReportParams();
      reportParams.area = 'SelfCare';
      reportParams.subArea = 'Private Debt Payment';
      reportParams.channel = 'WebsitePrivate';
      reportParams.actionType = 'Debt List Page';
      reportParams.banId = props.savedCustomerData?.number;
      reportParams.idNumber = props.savedCustomerData?.idNumber;
      reportParams.status = 'Error';
      reportParams.messageText = 'General Error';
      reportParams.subscriber = props.phoneNumber;
      report(reportParams);
    } else {
      setMount(false);
    }
  }, [props.currentStep]);

  return (
    <CSSTransition key={12} in={mount} timeout={250} classNames='stepwrapper' mountOnEnter unmountOnExit>
      <Container fluid className='debtpayment-step'>
        <Row className='debtpayment-container justify-content-md-center'>
          <Col md='auto'>
            <BasicText text='תשלום חוב' classname='debtpayment-title' />
          </Col>
        </Row>
        <Row className='debtpayment-step-title justify-content-md-center'>
          <Col md='auto'>
            <BasicText text={'שירות זה אינו זמין'} classname={'main-text-extra-bold'} />
          </Col>
        </Row>
        <Row className='debtpayment-step-subtitle justify-content-md-center'>
          <Col md='auto'>
            <BasicText text={'אנא נסו שוב במועד מאוחר יותר.\nלתשלום פנו למוקד הפיננסי'} />
          </Col>
        </Row>
        {props.isMobile ? (
          <Action
            text={'חיוג ' + numWithStarRTL(window.Config.financeCallNumber1) + ' לנציג פיננסי'}
            img={dial}
            onclick={actionOnClick}
            fnParams={window.Config.financeCallNumber1}
            bold
          />
        ) : (
          <Row className='justify-content-md-center'>
            <Col>
              <BasicText text={'חייגו ' + numWithStarRTL(window.Config.financeCallNumber1) + ' לנציג פיננסי'} bold color='businessPurple' />
            </Col>
          </Row>
        )}
        <Row className='justify-content-md-center main-img'>
          <Col md='auto'>
            <BasicImage src={mainImg} />
          </Col>
        </Row>
        <Row className='justify-content-md-center footer-btn'>
          <Col md='auto'>
            <BtnSubmit formid='' text='סיום' onclick={props.onclick} />
          </Col>
        </Row>
      </Container>
    </CSSTransition>
  );
};

export default GeneralErrorPrivate;
